import { Highcharts } from "extensions/highcharts";

import { toHex } from "common/colors";
import { v2 } from "common/config/api";
import strings from "common/strings";
import { accounting } from "common/utils";
import { formatAmountWithCurrentCurrency, getDefaultCurrentCurrency } from "common/formats";

import { DefaultTypeConfig } from "./default";

export const fees = function(options) {
    const opts = {
        by: "amount",
        ...options
    };

    const sortRate = (a, b) => (accounting.fees.grossEffectiveRate(a) < accounting.fees.grossEffectiveRate(b) ? -1 : 1);
    
    return new DefaultTypeConfig(opts, {
        urlRoot: "analytics/fees",
        api_endpoint(pivot = ["date_time"]) {
            return v2.fees.byPivot(Array.isArray(pivot) ? pivot : [pivot]);
        },
        totals: {
            fees_amount: "fees_amount",
            sales_amount: "sales_amount"
        },
        quick: {
            chart: {
                type: "AreaLine",
                series: [{
                    type: "area",
                    pointFormat: [DefaultTypeConfig.date_unix, DefaultTypeConfig.keyToFunc["fee_rate"]()],
                    extend: {
                        fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                        color: toHex("canvas-white")
                    }
                }]
            },
            data: {
                summaryTemplate: "summary2",
                widgetValueTemplateData: {
                    effectiveRate: {
                        value(model) {
                            const value = accounting.fees.grossEffectiveRate(model, {
                                humanize: true,
                                addFloatValue: false
                            });
                            
                            return Number.isNaN(value) ? "-" : value;
                        },
                        headerTemplateKey: "calculatedValue",
                        activeValue: true
                    },
                    totalFees: {
                        value: "fees_amount",
                        type: "amount",
                        headerTemplateKey: "val1",
                        activeValue: true,
                        label: strings.dashboard.widgets.fees_rate.feesPaid
                    },
                    totalSales: {
                        value: "sales_amount",
                        type: "amount",
                        headerTemplateKey: "val2",
                        activeValue: true,
                        label: strings.salesAmount
                    }
                }
            },
            reactProps: {
                chartField: "effective_fee_rate",
                chartFieldToggle: false,
                chartFieldDataType: "rate",
                secondaryField: "fees_amount",
                secondaryFieldDataType: "amount",
                summaryLabel: "FEES PAID",
                fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                color: toHex("canvas-white")
            }
        },
        trendline: {
            reactProps: {
                showBadgeInTabs: false,
                tablePivot: "currency_alias",
                tableHeaders: ["TRANSACTION CURRENCY", "TRANSACTION COUNT", "TRANSACTION AMOUNT"],
                countField: "effective_fee_rate",
                otherCountField: "sales_amount",
                // countFieldGetter: "??", // effective_fee_rate
                // otherCountFieldGetter: "5af0f36edcfa183102e8df3d", // sales_amount
                summaryStyle: 3,
                summaryTitle: "FEES",
                tooltipPrefix: "Fees",
                chart: "table"
            }
        },
        table: {
            columns: [{
                id: "Actor",
                header: "", // This field is changed by tableView.js
                template(model, pivot) {
                    return DefaultTypeConfig.references.toAlias(model[pivot], pivot);
                },
                sort: "string"
            }, {
                id: strings.dashboard.rate,
                template(model) {
                    return accounting.fees.grossEffectiveRate(model, {
                        humanize: true
                    });
                },
                header: strings.dashboard.rate,
                initialSorting: [sortRate, "desc"],
                css: "value",
                sort: sortRate
            }, {
                id: strings.analytics.feesPage.feeAmount,
                header: strings.analytics.feesPage.feeAmount,
                template: (model) => {
                    const { currency, decimals } = getDefaultCurrentCurrency();
                    return formatAmountWithCurrentCurrency(accounting.fees.getTotalFeesAmount(model), {
                        abbreviate: true, symbol: currency, symbolPosition: 1, precision: decimals
                    });
                },
                css: "amount",
                sort: (a, b) => (accounting.fees.getTotalFeesAmount(a) < accounting.fees.getTotalFeesAmount(b) ? -1 : 1)
            }, {
                id: "sales_amount",
                header: strings.salesAmount,
                css: "amount",
                template: (model) => {
                    const { currency, decimals } = getDefaultCurrentCurrency();
                    return formatAmountWithCurrentCurrency(model.sales_amount, {
                        abbreviate: true, symbol: currency, symbolPosition: 1, precision: decimals
                    });
                },
                sort: "int"
            }]
        },
        pie: {
            pointValue: "fees_amount",
            pointType: "amount"
        }
    });
};
